import React, { useContext, useEffect, useRef, useMemo, useState, useCallback } from "react";
import "./MainCorp.css"

import { ContainerRestau } from "../../../../components/containerRestau/containerRestau";
import { AppContext } from "../../../../context/AppContext";

import DefilmentBar from "../../../../components/defilmentBar/defilmentBar";
import {  Restaurant, cityWithOtherPreposition, IndexablePage, neighborhoodsByCity, FilterValue} from "../../../../components/types/types";

import { RestaurantContext } from "../../../../context/RestaurantContext";
import { FiChevronDown, FiChevronRight, FiChevronUp, FiHome, FiInfo } from "react-icons/fi";
import { BsFilterLeft } from "react-icons/bs";
import { useClickOutside } from "../../../../components/hook/clickOutside";

import imgMap from '../../../../image/blocMap.webp'
import { ImMap2 } from "react-icons/im";
import { useLocation, useNavigate } from "react-router-dom";
import { buildRestaurantTypeLabel } from "../../../../components/types/restaurantTypes";
import { buildPageTitle, ExtendedFilterSection, HookListSort,normalizeCity,RenderExtendedFilterSections,useExtendedFilterSearch } from "./hookMainCorp";
import { useViewportMaxHeight } from "../../../../components/hook/hookViewPortHeight";

const normalize = (value?: string | null): string => {
    return value
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/['"]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase() || "";
}

interface MainCorpProps {
    cityLoad?:string,
    cityLoadBrut?:string,
    seoPage?: IndexablePage | null;
    color?:string,
    setCurrentFilter: React.Dispatch<React.SetStateAction<FilterValue[]>>;
    routeCity?:string,
    getNeighborhoodResultCount: (neighborhoods: string[]) => number;
}

const MainCorp:React.FC<MainCorpProps> = ({cityLoad='',cityLoadBrut='',routeCity,seoPage,color,setCurrentFilter,getNeighborhoodResultCount}) => {
    const {setFilterChoose,setValueSearchCity,setDate_selected,setHour_selected,setCoordonates,currentHomePage, setSearchCity,setCurrentHomePage,homeImagesUnlocked,setHomeImagesUnlocked,currentNeighborhood,setCurrentNeighborhood,filterChoose,date_selected,hour_selected, idRestaurant,setShowCookies,setPreferencesCookies,setIntentGoMap,intentGoMap} = useContext(AppContext)
    const { listRestoFiltered , listRestoBackup, listResto  } = useContext(RestaurantContext)
    const currentYear = new Date().getFullYear();
    const pageTitle   = buildPageTitle(cityLoad, seoPage, currentYear);
    const title = `QuelResto vous permet de trouver facilement un bon restaurant en ligne.`

    const isDesktop = window.matchMedia("(min-width:701px)").matches;
    const LIMIT = isDesktop ? 12 : 3;
    const INITIAL_LIMIT = isDesktop ? 16 : 4;
    const containerRestoRef = useRef<HTMLDivElement>(null)

    const hasNeighborhoods = neighborhoodsByCity[normalize(cityLoadBrut)];
    const [showSortOptions,setShowSortOptions] = useState(false)
    const [tempNeighborhood, setTempNeighborhood] = useState<string[]>([]);
    useEffect(() => {
        if (!showSortOptions) {
            setTempNeighborhood(currentNeighborhood);
        }
    }, [currentNeighborhood, showSortOptions]);
    const refSortOption = useRef<HTMLDivElement>(null)
    useClickOutside(refSortOption, showSortOptions, () => {
        setShowSortOptions(false);
        setTempNeighborhood(currentNeighborhood)
    });
    useEffect(() => {
        if (!showSortOptions) return;
        const handleScroll = () => {
             if (ignoreNeighborhoodScrollRef.current) return;
            setShowSortOptions(false);
            setTempNeighborhood(currentNeighborhood);
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [showSortOptions, currentNeighborhood]);

    const hasNeighborhoodChanged = useMemo(() => {
        if (tempNeighborhood.length !== currentNeighborhood.length) return true;
        if(tempNeighborhood.length > 0) return true;
        return false
    }, [tempNeighborhood, currentNeighborhood]);

    useEffect(() => {
        if(listRestoFiltered && listRestoFiltered.length > 0){setCurrentHomePage(1);window.scrollTo({ top: 0, behavior: 'smooth' })}
    },[listRestoFiltered])
    useEffect(() => {
        if(currentNeighborhood && currentNeighborhood.length > 0){setCurrentHomePage(1);window.scrollTo({ top: 0, behavior: 'smooth' })}
    },[currentNeighborhood])


    const PAGE_SIZE = isDesktop ? 32 : 30;
    const targetCityNormalized = useMemo(() => normalizeCity(cityLoadBrut),[cityLoadBrut]);
    const doSplit = useMemo(() => !!targetCityNormalized && targetCityNormalized !== normalizeCity("à proximité"),[targetCityNormalized]);
    const tempResultCount = useMemo(() => {
        return getNeighborhoodResultCount(tempNeighborhood);
    }, [tempNeighborhood,getNeighborhoodResultCount]);
    const [showNoNeighborhoodResult, setShowNoNeighborhoodResult] = useState(false);
    useEffect(() => {
        if (!showNoNeighborhoodResult) return;
        const timeout = setTimeout(() => {
            setShowNoNeighborhoodResult(false);
        }, 3500);
        return () => clearTimeout(timeout);
    }, [showNoNeighborhoodResult]);
    const sortedList = useMemo(() => {
        const base = listRestoFiltered ?? [];
        if (!base.length) return [];

        const filtered = currentNeighborhood.length > 0
            ? base.filter(r => currentNeighborhood.includes(r.neighborhood))
            : base;

        const boostFirst = (arr: Restaurant[]) => {
            if (!idRestaurant || idRestaurant === -1) return arr;
            const copy = arr.slice();
            copy.sort((a, b) => {
            if (a.idrestaurant === idRestaurant) return -1;
            if (b.idrestaurant === idRestaurant) return 1;
            return 0;
            });
            return copy;
        };

        if (!doSplit) {
            return boostFirst(filtered);
        }

        const inCity: Restaurant[] = [];
        const visibleCityMatch: Restaurant[] = [];
        const around: Restaurant[] = [];

        for (const r of filtered) {
            const rCity = normalizeCity(r.address?.[1]);
            const rVisibleCity = normalizeCity(r.visiblecity);

            if (rCity === targetCityNormalized) {
                inCity.push(r);
            } else if (rVisibleCity === targetCityNormalized) {
                visibleCityMatch.push(r);
            } else {
                around.push(r);
            }
        }
        return [...boostFirst(inCity),...boostFirst(visibleCityMatch), ...boostFirst(around)];
    }, [listRestoFiltered, idRestaurant, cityLoadBrut,currentNeighborhood, doSplit,targetCityNormalized ]);

    const { indexFirstAround, hasCityResto } = useMemo(() => {
        if (!cityLoadBrut || cityLoadBrut === 'à proximité') return { indexFirstAround: -1, hasCityResto: true };
        if (!sortedList.length) return { indexFirstAround: -1, hasCityResto: false };
        const targetCity = normalizeCity(cityLoadBrut);
        const isInMainCityBlock = (r: Restaurant) => {
            const rCity = normalizeCity(r.address?.[1]);
            const rVisibleCity = normalizeCity(r.visiblecity);

            return rCity === targetCity || rVisibleCity === targetCity;
        };
        const hasCityResto = sortedList.some(isInMainCityBlock);
        
        if (!hasCityResto) {
            return { indexFirstAround: 0, hasCityResto: false };
        }
        const idx = sortedList.findIndex((r) => !isInMainCityBlock(r));
        return { indexFirstAround: idx, hasCityResto: true };
    }, [sortedList, cityLoadBrut]);

    const pageItems = useMemo(() => {
        const start = (currentHomePage - 1) * PAGE_SIZE;
        return sortedList.slice(start, start + PAGE_SIZE);
    }, [sortedList, currentHomePage, PAGE_SIZE]);

    const totalFiltered = sortedList.length;
    const lastPageFiltered = Math.max(1, Math.ceil(totalFiltered / PAGE_SIZE));
    const isLastFilteredPage = currentHomePage === lastPageFiltered;
    useEffect(() => {
        window.scrollTo({top: 0,behavior: 'auto'})
    },[hour_selected,date_selected,filterChoose])

    const mainCorpRef = useRef<HTMLDivElement>(null);
    const ignoreNeighborhoodScrollRef = useRef(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (window.innerWidth > 700 || !pageItems?.length) return;

        const root = mainCorpRef.current;
        if (!root) return;

        const containers = Array.from(
            root.querySelectorAll<HTMLElement>(".containerRestauUp")
        );

        if (!containers.length) return;

        let currentCentered: HTMLElement | null = null;
        const ratios = new Map<HTMLElement, number>();

        const setCentered = (next: HTMLElement | null) => {
            if (currentCentered === next) return;

            if (currentCentered) {
                currentCentered.classList.remove("centered");
            }

            if (next) {
                next.classList.add("centered");
            }

            currentCentered = next;
        };

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    ratios.set(entry.target as HTMLElement, entry.intersectionRatio);
                });

                let best: HTMLElement | null = null;
                let bestRatio = 0;

                ratios.forEach((ratio, elem) => {
                    if (ratio > bestRatio) {
                        bestRatio = ratio;
                        best = elem;
                    }
                });

                setCentered(bestRatio > 0.15 ? best : null);
            },
            {
                threshold: [0, 0.25, 0.5, 0.75, 1],
                rootMargin: "-35% 0px -35% 0px",
            }
        );

        containers.forEach((container) => {
            ratios.set(container, 0);
            observer.observe(container);
        });

        return () => {
            observer.disconnect();
            setCentered(null);
        };
    }, [pageItems]);

    useEffect(() => {
        if (homeImagesUnlocked) return;
        const needsUnlock = pageItems.length > INITIAL_LIMIT;
        if (!needsUnlock) {
            setHomeImagesUnlocked(true);
            return;
        }

        const el = containerRestoRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            (entries) => {
            if (entries[0]?.isIntersecting) {
                setHomeImagesUnlocked(true);
                observer.disconnect();
            }
            },
            { threshold: 0.1 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [pageItems, homeImagesUnlocked, INITIAL_LIMIT, setHomeImagesUnlocked]);

    
    const handleClickSort = (values: string[]) => {
        if (values.length === 0) return;
        const uniqueValues = Array.from(new Set(values));
        setTempNeighborhood((prev) => {
            const areAllSelected = uniqueValues.every((value) => prev.includes(value));
            if (areAllSelected) return prev.filter((value) => !uniqueValues.includes(value));
            return Array.from(new Set([...prev, ...uniqueValues]));
        });
    };


    const navigate = useNavigate()
    const location = useLocation()
    const handleMap = () => {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        if (cookie) {
            const cookieValue = cookie.split('=')[1];
            try {
                const decode = decodeURIComponent(cookieValue)
                const cookieData = JSON.parse(decode);
                if (cookieData['perform-analytics']) {
                    navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,returnState: {...(location.state ?? {}),topBarMode: "search"}}});
                } else {
                    setShowCookies(true)
                    setPreferencesCookies(true) 
                    setIntentGoMap(1)
                }
            } catch (error) {
                setShowCookies(true)
                setPreferencesCookies(true)
                setIntentGoMap(1)
            }
        } else {
            setShowCookies(true)
            setPreferencesCookies(true)
            setIntentGoMap(1)
        }
    }
    useEffect(() => {
        if(intentGoMap === 2) {
            setIntentGoMap(0)
            navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,returnState: {...(location.state ?? {}),topBarMode: "search"}}});
        }
    },[intentGoMap])

    const nbrResultUse = indexFirstAround === -1 ? sortedList.length : indexFirstAround;
    const nbrResultMoreUse = sortedList.length - indexFirstAround;
    const baseResultCount = doSplit ? nbrResultUse : sortedList.length;

    const cleanAllFilters = useCallback(() => {
        setCoordonates({ latitude: "", longitude: "" });
        setFilterChoose([]);
        setDate_selected(null);
        setHour_selected("");
        setCurrentHomePage(1);
        setCurrentNeighborhood([]);
    }, [setCoordonates,setFilterChoose,setDate_selected,setHour_selected,setCurrentHomePage,setCurrentNeighborhood]);
    const cleanCity = useCallback(() => {
        setSearchCity("");
        setValueSearchCity("");
    }, [setSearchCity,setValueSearchCity]);
    const handleBreadcrumbHome = () => {
        cleanAllFilters();
        cleanCity();
        navigate("/")
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleBreadcrumbCity = () => {
        cleanAllFilters();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleBreadcrumbAllResto = () => {
        cleanAllFilters();
        navigate('/restaurants')
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleBreadcrumbFilter = () => {
        if (!seoPage?.filter_slug || !seoPage?.filter_name) return;

        cleanAllFilters();

        if (seoPage.city_name) {
            setSearchCity(seoPage.city_name);
            setValueSearchCity(seoPage.city_name);
        }
        const filterValue = seoPage.filter_slug.includes(":") ? seoPage.filter_slug : seoPage.filter_name;
        setFilterChoose([filterValue]);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleToggleNeighborhoodSort = () => {
        if (showSortOptions) {
            setShowSortOptions(false);
            return;
        }
        setTempNeighborhood(currentNeighborhood);
        const isShortTablet = window.innerWidth > 700 && window.innerHeight < 800;
        const isAtTop = window.scrollY < 250;
        if (isShortTablet && isAtTop) {
            ignoreNeighborhoodScrollRef.current = true;
            window.scrollTo({top: 250,behavior: "smooth"});
            setShowSortOptions(true);
             window.setTimeout(() => {
                ignoreNeighborhoodScrollRef.current = false;
            }, 500);
            return;
        }
        setShowSortOptions(true);
    };
    const selectedNeighborhoodCount = useMemo(() => {
        if (!hasNeighborhoods) return 0;
        return hasNeighborhoods.reduce((total, [, neighborhoodGroups]) => {
            const selectedGroupsCount = neighborhoodGroups.filter(
                group => group.length > 0 && group.every(value => tempNeighborhood.includes(value))
            ).length;
            return total + selectedGroupsCount;
        }, 0);
    }, [hasNeighborhoods, tempNeighborhood]);

    const handleShowAllExtendedFilter = useCallback((section: ExtendedFilterSection) => {
        if (section.isPriceSection && section.replacementFilter) {
            const [rawMinPrice, rawMaxPrice] = section.replacementFilter!;
            const minPrice = Number(rawMinPrice);
            const maxPrice = Number(rawMaxPrice);
            const clampedPrice: [number, number] = [Math.max(0, Math.min(100, minPrice)),Math.max(0, Math.min(100, maxPrice))];
            setFilterChoose((prev) => {
                const withoutOldPrice = prev.filter((filter) => !Array.isArray(filter));
                return [...withoutOldPrice,clampedPrice];
            });
            setCurrentFilter((prev) => {
                const withoutOldPrice = prev.filter((filter) => !Array.isArray(filter));
                return [...withoutOldPrice,clampedPrice];
            });
        } else {
            const seoPageFilter = seoPage?.filter_slug && seoPage?.filter_name ? (seoPage.filter_slug.includes(":") ? seoPage.filter_slug : seoPage.filter_name): null;
            const removesIndexedPageFilter = !!seoPageFilter &&  normalize(section.filterLabel) === normalize(seoPageFilter);
            setCurrentFilter((prev) => prev.filter((filter) => filter !== section.filterLabel))
            setFilterChoose((prev) => prev.filter((filter) => filter !== section.filterLabel));
            if (removesIndexedPageFilter) {
                if (seoPage?.city_name && routeCity) {
                    navigate(`/${routeCity}`, {state: { topBarMode: "search" }});
                } else {
                    navigate("/", {state: { topBarMode: "search" } });
                }
            }
        }
        setCurrentHomePage(1);
        window.scrollTo({top: 0,behavior: "smooth"});
    },[seoPage,routeCity,navigate,setFilterChoose,setCurrentHomePage]);

    const extendedFilterSections = useExtendedFilterSearch({listResto,filterChoose,dateSelected: date_selected,hourSelected: hour_selected,currentNeighborhood,doSplit,targetCityNormalized,sortedList,indexFirstAround,baseResultCount});
    const lockedNeighborhoodGroups = useMemo(() => {
        const locked = new Set<string>();
        if (!hasNeighborhoods) return locked;
        for (const [, neighborhoodGroups] of hasNeighborhoods) {
            for (const group of neighborhoodGroups) {
                const isAlreadySelected =group.length > 0 && group.every((value) => tempNeighborhood.includes(value));
                if (isAlreadySelected) continue;
                if (getNeighborhoodResultCount(group) === 0) locked.add(group.join("||"));
            }
        }
        return locked;
    }, [hasNeighborhoods,tempNeighborhood,getNeighborhoodResultCount]);
    const {ref: listNeighboorRef,maxHeight: listNeighboorMaxHeight} = useViewportMaxHeight(showSortOptions);
    const [isResultCountLoading, setIsResultCountLoading] = useState(false);
    useEffect(() => {
        setIsResultCountLoading(true);
        const timeout = window.setTimeout(() => {
            setIsResultCountLoading(false);
        }, 500);
        return () => {
            window.clearTimeout(timeout);
        };
    }, [tempNeighborhood]);

    return (
            <div className="mainCorpRestau" id='mainCorpRestau' ref={mainCorpRef} style={color ? {background:color} : {}}>
                <div className="blocMapPhone smallText flexAllCenter" onClick={handleMap}>
                    <img src={imgMap} decoding="async" alt="map" />
                    <div className="shadow"></div>
                    <span className="smallWhiteRoundButton primaryBack" ><ImMap2 className="icon" size={15}/>Ouvrir la map</span>
                </div>
                <div className="wrapperArianWire">
                    <div className="shadowLeft"></div>
                    <div className="shadowRight"></div>
                    <div className={`arianWire XsmallText ${currentHomePage !== 1 ? 'isFirstTop' : ''}`}>
                        <FiHome className="elem iconHome pointer" onClick={handleBreadcrumbHome} size={15}/>
                        {cityLoad && <div className={`elem pointer ${seoPage?.filter_name ? '' : 'isLast'}`} onClick={handleBreadcrumbCity}>
                            <FiChevronRight className="icon"/>
                            <span>Restaurants {cityLoad}</span>
                        </div>}
                        {seoPage?.filter_name && <div className="elem isLast pointer" onClick={handleBreadcrumbFilter}>
                            <FiChevronRight className="icon"/>
                            <span>{seoPage?.filter_name}</span>
                        </div>}
                        {(!cityLoad && !seoPage?.filter_name) && <div className="elem isLast pointer" onClick={handleBreadcrumbAllResto}>
                            <FiChevronRight className="icon"/>
                            <span>Maine-et-Loire</span>
                        </div>}
                    </div>
                </div>
                {(pageTitle && currentHomePage === 1) && (
                    <div className="titleCityLoad">
                        <h1 className="largerTitle">{pageTitle}</h1>
                        <div className="listFilterHook">
                            {hasNeighborhoods &&  <>
                                <div className="sortNeighborHood XsmallText" ref={refSortOption}>
                                    <div className="smallWhiteRoundButton"  onClick={handleToggleNeighborhoodSort}>
                                        <BsFilterLeft size={18} />
                                        <span>Trier par quartier {tempNeighborhood.length > 0 ? `(${selectedNeighborhoodCount})` : ''}</span>
                                        {showSortOptions ? <FiChevronUp size={18} className="icon" /> : <FiChevronDown size={18} className="icon" />}
                                    </div>
                                    {showSortOptions && <div className='list primaryBack' ref={listNeighboorRef} style={listNeighboorMaxHeight ? { maxHeight: `${listNeighboorMaxHeight}px` } : undefined}>
                                        <div className="scrollPart">
                                            {hasNeighborhoods.map((elem,id) => {
                                                const neighborhoodGroups = elem[1];
                                                const availableGroups = neighborhoodGroups.filter(group => {
                                                    const isSelected = group.length > 0 && group.every(value =>tempNeighborhood.includes(value));
                                                    return (isSelected ||getNeighborhoodResultCount(group) > 0);
                                                });
                                                const availableSectionValues = Array.from(new Set(availableGroups.flat()));
                                                const isSectionLocked = availableGroups.length === 0;
                                                return <React.Fragment key={'sortOption'+id}>
                                                    <HookListSort elem={elem} handleClickSort={handleClickSort} currentList={tempNeighborhood} lockedGroups={lockedNeighborhoodGroups} isSectionLocked={isSectionLocked} availableSectionValues={availableSectionValues} onLockedClick={() => setShowNoNeighborhoodResult(true)}/>
                                                    {id < hasNeighborhoods.length - 1 &&  <div className="separationList"></div>}
                                                </React.Fragment>
                                            })}
                                        </div>
                                        <div className="bottomPart XsmallText">
                                            {showNoNeighborhoodResult && showSortOptions && <div className="containerCantSearch smallText">
                                                <FiInfo className='icon' />
                                                <div>Aucun résultat pour ce quartier. Essayez d'enlever un ou plusieurs filtres.</div>
                                            </div>}
                                            <span className={`smallWhiteRoundButton ${selectedNeighborhoodCount === 0 ? 'notActive' : ''}`} onClick={() => setTempNeighborhood([])}>Tout effacer</span>
                                            <span className={`smallGoldRoundButton ${!hasNeighborhoodChanged ? 'isLocked' : ''}`} onClick={() => {setCurrentNeighborhood(tempNeighborhood);setShowSortOptions(false)}}>{isResultCountLoading ? <div className="countSpinnerLoad" /> :  <>{`Afficher (${tempResultCount} résultat${tempResultCount > 1 ? "s" : ""})`}</>}</span>
                                        </div>
                                    </div>
                                    }
                                    
                                </div>
                                {showSortOptions && <div className="maskHookSortNeighborHood"></div>}
                                </>
                            }
                        </div>
                        
                    </div>
                )}
                {currentHomePage === 1 && <span className="subTitle XsmallText">{`${nbrResultUse} restaurant${nbrResultUse>1? 's' : ''}`} <div></div> {'Maine-et-Loire – 2026'}</span>}

                {!hasCityResto && listRestoFiltered.length > 0 && cityLoad && <p className="title midText explainCity" >Aucun restaurant correspondant dans la ville recherchée</p>}
                { 
                    listRestoFiltered.length > 0 ? 
                    <>{
                        pageItems.map((elem,index) => {
                            const globalIndex = (currentHomePage - 1) * PAGE_SIZE + index;
                            const showAroundTitle =
                                !!cityLoad &&
                                cityLoad !== 'restaurants-a-proximite' &&
                                indexFirstAround !== -1 &&
                                globalIndex === indexFirstAround;
                            return <React.Fragment key={'elemListContainer' + elem.idrestaurant}>
                                {showAroundTitle && (<>
                                        {currentHomePage === 1 && extendedFilterSections.length > 0 && <RenderExtendedFilterSections extendedFilterSections={extendedFilterSections} onShowAll={handleShowAllExtendedFilter} />}
                                        <div className="aroundTitle">
                                            <div className={`line ${(currentHomePage === 1 && extendedFilterSections.length > 0) ? 'isHidden' : ''} ${(!hasCityResto && listRestoFiltered.length > 0 && cityLoad) ? 'isAtTop' : ''}`}></div>
                                            <h2 className="largerTitle">
                                                Recherche étendue : Trouvez un bon restaurant aux alentours {cityWithOtherPreposition(cityLoad)}
                                            </h2>
                                            <span className="subTitle XsmallText">{`${nbrResultMoreUse} restaurant${nbrResultMoreUse>1? 's' : ''}`} <div></div> {'Maine-et-Loire – 2026'}</span>
                                        </div>
                                    </>
                                )}
                                <ContainerRestau  imgLocked={!homeImagesUnlocked ? index > INITIAL_LIMIT : false} id={index}  visibleCity={elem.visiblecity || ''} city={elem.address[1]} price_range={elem.price_range} idResto={elem.idrestaurant}   img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} type={elem.type_display || buildRestaurantTypeLabel(elem.type)} nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}
                                    def_cuisine={elem.def_cuisine}  neighborhood={elem.neighborhood} />   
                                {currentHomePage===1 && index === LIMIT &&  (
                                <div ref={containerRestoRef} style={{ height: 1 }} />
                                )}
                            </React.Fragment>
                            })
                        }
                        {currentHomePage === 1 && indexFirstAround === -1 && extendedFilterSections.length > 0 && <RenderExtendedFilterSections extendedFilterSections={extendedFilterSections} onShowAll={handleShowAllExtendedFilter} />}
                        </>
                        :
                        <div className="noFilterMatch">
                            {
                                listRestoBackup && listRestoBackup.length > 0 ?
                                <>
                                    <p className="titleList midText">Liste de restaurant se rapprochant le plus de votre recherche :</p>
                                    <div className="liste">
                                        {
                                        listRestoBackup.length > 0  && listRestoBackup.slice((currentHomePage-1)*PAGE_SIZE,currentHomePage*PAGE_SIZE).map((elem,index) => (
                                            <ContainerRestau id={index} key={'secondContainer'+elem.idrestaurant} visibleCity={elem.visiblecity || ''} city={elem.address[1]} price_range={elem.price_range}  idResto={elem.idrestaurant} img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} type={elem.type_display || buildRestaurantTypeLabel(elem.type)}  nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}
                                            def_cuisine={elem.def_cuisine}  neighborhood={elem.neighborhood} />   
                                        ))
                                        }
                                    </div>
                                </>
                                :
                                <p className="title midText explainNoResto" >{cityLoad && filterChoose.length === 0 ? 'Aucun restaurant correspondant dans la ville recherchée' : `Aucun restaurant correspondant à votre recherche. Essayez d’enlever un ou plusieurs filtres pour voir plus de résultats.`}</p>
                            }
                        </div> 
                }
                {listRestoFiltered.length > 0 && isLastFilteredPage && (
                    <div className="mainCorpTextAccueil">
                        <div className="textAccueil smallText">
                            {pageTitle ? <h2>{title}</h2> : <h1>{title}</h1>}<br/>
                            Ouvert depuis l'été 2025, notre objectif est de référencer tous les bons restaurants du Maine-et-Loire.
                        </div>
                        <p className="textAccueil XsmallText" style={{marginTop:'3em'}}>
                           Pour en savoir plus : <a href="/APropos" className="link">À propos de QuelResto</a> et <a href="/Fonctionnement" className="link">Fonctionnement du site</a>.
                        </p>
                    </div>
                )}

                {listRestoBackup && listRestoBackup.length > 0 && <DefilmentBar currentPage={currentHomePage} totalResult={sortedList.length > 0 ?  sortedList.length : (listRestoBackup && listRestoBackup.length > 0 ? listRestoBackup.length : 0) } nbrForPage={PAGE_SIZE} setCurrentPage={setCurrentHomePage} nbrPages={Math.ceil(sortedList.length / PAGE_SIZE)} scrollToTop={true}/> }
            </div>
    )
}
export default MainCorp